import { SettingsManager } from "@viamap/viamap2-common"
import { EjendomDataFormated, EjendomEjerskab, EjendomHandel, ViamapEjendomStatsData } from "./DLLTypes";

export class dllCollector {

   static async EjendomData(BFENummer: string): Promise<EjendomDataFormated> {
      const body = {
         "SagsNr": "ASM_1",
         "BFEnr": BFENummer,
         "Matrikler": []
      }
      return fetchDLL("getEjendomDataFormated?BFEnr=" + BFENummer, body);
   }

   static async EjendomHandel(BFENummer: string): Promise<EjendomHandel> {
      const body = {
         "BFEnr": BFENummer
      }
      return fetchDLL("getHandelsOplysning", body);
   }

   static async EjendomEjerskab(BFENummer: string): Promise<EjendomEjerskab> {
      const body = {
         "BFEnr": BFENummer
      }
      return fetchDLL("getejerskab", body, "GET");
   }

   static async OmrådeStatistikEjendomme(kommuneNr: string, postNr: string): Promise<ViamapEjendomStatsData> {
      const body = {
         "kommuneNr": kommuneNr,
         "postNr": postNr,
         "kategori": "1"
      };
      return fetchDLL("getEjendomStats", body);
   }


}

function fetchDLL(endpoint: string, body: any, type: "POST" | "GET" = "POST"): Promise<any> {
   const baseUrl = SettingsManager.getSystemSetting("dllServicesUrl");
   const url = "https://" + baseUrl + "/" + endpoint;
   const API_KEY = SettingsManager.getSystemSetting("dllServicesKey");
   return fetch(url + (type === "GET" ? "?" + new URLSearchParams(body).toString() : ""), {
      method: type,
      headers: {
         "X-API-KEY": API_KEY ? API_KEY : "",
         "Content-Type": "application/json"
      },
      body: type === "POST" ? JSON.stringify(body) : undefined
   }).then((response) => {
      if (!response.ok) {
         throw new Error("Network response was not ok");
      }
      return response.json();
   });
}



